import Vue from 'vue'
import store from '@/store'
import Router from '@/router/index'

/**
 * getInterceptorsRequest
 * @param {*} isJson
 * @returns
 */
export function getInterceptorsRequest (isJson) {
  return function interceptorsRequest (config) {
    const isGetMethod = config.method === 'get'
    const showError = config.showError === undefined ? true : config.showError
    config.headers['Authorization'] = 'Bearer ' + store.getters.token
    if (isGetMethod) {
      config.params = {
        ...config.params,
        ...config.data
      }
    } else if (isJson) {
      config.data = {
        ...config.data
      }
    }
    config.showError = showError
    return config
  }
}
/**
 * @Message("Auth Error！") 40101
 * @Message("Invalid token！") 40102
 * @Message("Token has expired！") 40103
 */
export function errorToast (data) {
  const { errcode, errmsg } = data
  if (errcode == 40101) {
    Vue.prototype.$message.error('账号密码错误，请重新登录')
  } else if (errcode == 40102) {
    Vue.prototype.$message.error('登录信息已过期，请重新登录')
    let authPath =
      process.env.VUE_APP_STATUS == 'uat' || location.host == 'jd.yuanyuanke.cn'
        ? '/auth/phoneLogin'
        : '/auth/login'
    store.commit('clearUser')
    Router.push({ path: authPath, replace: true })
  } else {
    Vue.prototype.$message.error(errmsg)
  }
}

/**
 * 对reqErr进行拦截并抛出errMsg
 *
 * @param {*} res 返回值
 * @param {*} msg msg
 * @returns err
 */

export function reqErr (res, msg = '') {
  const { data } = res.data || {}
  msg = data.msg || data.err_msg || msg
  const err = new Error(msg)
  err.res = res

  return err
}

/**
 *
 * @param {*} inst
 */

export function resolveGetMethod (inst) {
  const origGetMethod = inst.get

  inst.get = function (url, _params, config = {}) {
    // 兼容finder params
    if (_params) {
      const { params } = _params
      if (params && params.finderId) {
        config = {
          ..._params,
          ...config
        }
      } else {
        config = {
          params: _params,
          ...config,
          ..._params
        }
      }
    }
    console.log('resolveGetMethod',url, config)
    return origGetMethod(url, config)
  }
}

//域名白名单
export const whiteApi = ['/salesperson/unique-visito/export']
